import React, { useCallback } from "react";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { FontIcon } from "@companion-core/shared/app/Components/FontIcon";
import { Button } from "@companion-core/shared/app/Components/Button";
import { BellConfirmationProps } from ".";
import { trackClickBell } from "@companion-core/shared/app/tracking/bell";
import { useBellStore } from "@companion-core/shared/app/Store/bellStore";
import { useWizardStore } from "@companion-core/shared/app/Store/wizardStore";
import { getInitialBellContent } from "@companion-core/shared/app/Utils/bell";
import { getModule } from "@companion-core/shared/app/Utils/config";
import "Assets/Styles/scss/bellConfirmation.scss";

export const BellConfirmation = ({ requestStatus = "success", onClick }: BellConfirmationProps) => {
  const { t } = useTranslation();
  const status = requestStatus === "success" ? "success" : "error";
  const { clearBell, setIsPopUpVisible } = useBellStore((state) => ({
    clearBell: state.clearBell,
    setIsPopUpVisible: state.setIsPopUpVisible,
  }));
  const { resetWizard } = useWizardStore((state) => ({ resetWizard: state.resetWizard }));
  const displayNeedHelpErrorLink = getModule("need-help")?.enabled;

  const resetAll = useCallback(() => {
    resetWizard();
    clearBell(getInitialBellContent());
    setIsPopUpVisible(false);
  }, [resetWizard, clearBell]);

  return (
    <div data-testid="bell__confirmation" className="bell__confirmation">
      <div className="bell__confirmation-container">
        <div className="bell__confirmation-icon">
          <FontIcon name={status === "success" ? "JP-Circle-check" : "JP-Circle-close"} size={46} />
        </div>
        <h3 className="bell__confirmation-title title-2">
          {t(`requestV2.concierge.confirmation.${status}.title`)}
        </h3>
        <div className="bell__confirmation-subtitle body-text-6">
          {t(`requestV2.concierge.confirmation.${status}.subtitle`)}
          {status === "error" && displayNeedHelpErrorLink && (
            <Link
              data-testid="confirmation__link-need-help"
              to="/need-help"
              className="body-text-5"
              onClick={() => {
                resetAll();
                trackClickBell("help", "", "help");
              }}>
              {t("requestV2.concierge.confirmation.error.help.link")}
            </Link>
          )}
        </div>
      </div>
      <div className="bell__confirmation-button">
        <Button
          testID="bell__confirmation-button"
          type="primary"
          size="full"
          label={t(`requestV2.concierge.confirmation.${status}.buttonLabel`)}
          loading={requestStatus === "pending"}
          onClick={onClick}
        />
      </div>
    </div>
  );
};
